module.exports = __webpack_public_path__ + "img/michael-berkowitz.ff066c54.jpg";